module.exports = __webpack_public_path__ + "static/media/YF38_0.b48c3a1f.jpg";